module.exports = __webpack_public_path__ + "static/media/KOL2.b4b4d4a2.apng";